import React from "react";
import SearchBar from "../../common/searchbar/SearchBar";
import Sort from '../../common/sort/Sort'

const GroupDashboardCardHeader = ({ globalFilter, setGlobalFilter, setSorting }) => {

  return(
    <div className="msync-card__header msync-flex msync-flex--wrap">
      <SearchBar
        globalFilter={ globalFilter } 
        setGlobalFilter={ setGlobalFilter } 
      />
      <Sort 
        setSorting={setSorting}
        columnName="title" // what column to filter
        setSortDefault="asc"
      />
    </div>
  )

}

export default GroupDashboardCardHeader
